import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-forecast-not-found',
  templateUrl: './forecast-not-found.component.html',
  styleUrl: './forecast-not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule],
})
export class ForecastNotFoundComponent {}
